module.exports = __webpack_public_path__ + "static/media/S1N11-4.6a970178.svg";